import moment from "moment"
import { ACL_ROLES, Alias } from "../constants"
import { saveAs } from 'file-saver';
export const isRoot = roles => roles.indexOf(ACL_ROLES.ROOT) >= 0
export const isAdmin = roles => roles.indexOf(ACL_ROLES.ADMIN) >= 0
export const isDJ = roles => roles.indexOf(ACL_ROLES.DJ) >= 0

export const isResellerRole = role => ACL_ROLES.RESELLER.test(role)
export const resellStations = roles => roles.filter(isResellerRole).map(role => role.match(ACL_ROLES.RESELLER)[1])
export const isReseller = roles => roles.filter(isResellerRole).length > 0

export const isOwner = alias => !!(alias && alias.trim() !== '');
export const getOwnerEmail = (user) => user?.attributes?.isOwner ? user?.attributes?.username : user?.attributes?.ownerEmail;
export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}
export const uuidv1ToDate = (uuid) => {
  const uuidArr = uuid.split('-');
  const timeStr = [
    uuidArr[2].substring(1),
    uuidArr[1],
    uuidArr[0],
  ].join('');
  const intTime = parseInt(timeStr, 16) - 122192928000000000;
  const ms = Math.floor(intTime / 10000);
  return ms;
};

export const getToken = () => localStorage.getItem('authToken');
export const getTokenFromSession = () => sessionStorage.getItem("authToken");

export const getOffset = (page, limit) => parseInt(page) * parseInt(limit);

export const decodedText = (encodedText) => encodedText?.replace(/\\u([\dA-Fa-f]{4})/g, (match, group) =>
  String.fromCharCode(parseInt(group, 16))
);


export const toUnicode = (unicode) => {
  const alias = localStorage.getItem('alias');
  if (!Alias.includes(alias)) {
    return unicode;
  }
  let result = '';
  for (let i = 0; i < unicode.length; i++) {
    let partial = unicode[i].charCodeAt(0).toString(16);
    while (partial.length !== 4) {
      partial = `0${partial}`
    }
    result += `\\u${partial}`;
  }
  return result;
};

export const isOnline = (user) => {
  const {attributes: { lastActivityAt } } = user

  if (!lastActivityAt) return false
  return moment().subtract(30, 'minutes').isBefore(moment(lastActivityAt))
};


export const getStateOfPoll = (state) => {
  const PollStates = {
      CREATED: 0,
      STARTED: 1,
      STOPPED: 2,
      ENDED: 3,
      ARCHIVED: 4,
  };

  switch (state) {
      case PollStates.CREATED:
          return "Created";
      case PollStates.STARTED:
          return "Active";
      case PollStates.STOPPED:
          return "Stopped";
      case PollStates.ENDED:
          return "Ended";
      case PollStates.ARCHIVED:
          return "Archived";
      default:
          return "Unknown State";
  }
};

export const exportToCSV = (response, fileName = 'participants') =>  {
  if (!response|| !response.length) {
    console.warn('No data available for export.');
    return;
  }

  // CSV Header row
  const csvHeaders = [
    'User Name', 'User ID', 'Email','DOB','Gender', 'Postal Code', 
    'Registered Date', 'Last Activity Date', 'Status', 'Role'
  ];

  // Convert response payload into CSV rows
  const csvRows = response.map(user =>
    [
      `${user.name || ''}`,
      `${user.userId || ''}`,
      `${user.email || ''}`,
      `${user.DOB || ''}`,
      `${user.Gender || ''}`,
      `${user.zipcode || ''}`,
      `${user.joinedAt || ''}`,
      `${user.activity || ''}`,
      `${user.status || ''}`,
      `${user.role || ''}`
    ].join(',')
  );

  // Combine headers and rows
  const csvContent = [csvHeaders.join(','), ...csvRows].join('\n');

  // Create a Blob and trigger download
  const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, `${fileName}.csv`);
}


export const  pick = (obj, keys) =>{
  return keys.reduce((result, key) => {
    if (obj && Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = obj[key];
    }
    return result;
  }, {});
}

export const truncate = (text, max = 22) =>
  text && text.length > max ? text.slice(0, max) + "..." : text;